import { Text as DefaultText, View as DefaultView } from 'react-native';
import useColorScheme from 'src/presentation/hooks/useColorScheme';
import Colors from 'src/core/utils/Colors';

const themeColors = {
	light: { text: Colors.black, background: Colors.white },
	dark: { text: Colors.white, background: Colors.black },
} as const;

type ThemeName = keyof typeof themeColors;
type ThemeColorName = keyof (typeof themeColors)['light'];

export function useThemeColor(
	props: { light?: string | undefined; dark?: string | undefined },
	colorName: ThemeColorName,
) {
	const theme = useColorScheme() === 'dark' ? ('dark' satisfies ThemeName) : ('light' satisfies ThemeName);

	return props[theme] ?? themeColors[theme][colorName];
}

type ThemeProps = {
	lightColor?: string;
	darkColor?: string;
};

export type TextProps = ThemeProps & DefaultText['props'];
export type ViewProps = ThemeProps & DefaultView['props'];

export function Text(props: TextProps) {
	const { style, lightColor, darkColor, ...otherProps } = props;
	const color = useThemeColor({ light: lightColor, dark: darkColor }, 'text');

	return <DefaultText style={[{ color }, style]} {...otherProps} />;
}

export function View(props: ViewProps) {
	const { style, lightColor, darkColor, ...otherProps } = props;
	const backgroundColor = useThemeColor({ light: lightColor, dark: darkColor }, 'background');

	return <DefaultView style={[{ backgroundColor }, style]} {...otherProps} />;
}
